module.exports = __webpack_public_path__ + "media/images/admin/icons/chevron-down-c3e123cf78bc368a192f3e2dee97daba.svg";